// Hook for managing filter tabs scroll arrows (YouTube-style)
const FilterTabsScroll = {
  mounted() {
    this.scrollContainer = this.el.querySelector('#scroll-container')
    this.leftArrow = this.el.querySelector('#left-arrow')
    this.rightArrow = this.el.querySelector('#right-arrow')
    this.leftButton = this.el.querySelector('#left-arrow-button')
    this.rightButton = this.el.querySelector('#right-arrow-button')
    
    if (!this.scrollContainer || !this.leftArrow || !this.rightArrow) {
      return
    }
    
    // Check scroll position and update arrow visibility
    this.checkScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer
      const isScrollable = scrollWidth > clientWidth
      
      if (!isScrollable) {
        this.leftArrow.style.display = 'none'
        this.rightArrow.style.display = 'none'
        return
      }
      
      // Show/hide left arrow
      if (scrollLeft > 0) {
        this.leftArrow.style.display = 'flex'
      } else {
        this.leftArrow.style.display = 'none'
      }
      
      // Show/hide right arrow
      if (scrollLeft < scrollWidth - clientWidth - 1) {
        this.rightArrow.style.display = 'flex'
      } else {
        this.rightArrow.style.display = 'none'
      }
    }
    
    // Scroll functions
    this.scrollLeft = () => {
      this.scrollContainer.scrollBy({ left: -200, behavior: 'smooth' })
    }
    
    this.scrollRight = () => {
      this.scrollContainer.scrollBy({ left: 200, behavior: 'smooth' })
    }
    
    // Add event listeners
    this.scrollContainer.addEventListener('scroll', this.checkScroll)
    if (this.leftButton) {
      this.leftButton.addEventListener('click', this.scrollLeft)
    }
    if (this.rightButton) {
      this.rightButton.addEventListener('click', this.scrollRight)
    }
    
    // Initial check
    this.checkScroll()
    
    // Check on window resize
    this.resizeObserver = new ResizeObserver(() => this.checkScroll())
    this.resizeObserver.observe(this.scrollContainer)
  },
  
  updated() {
    // Re-check scroll position when the element updates
    this.checkScroll()
  },
  

  destroyed() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
    
    if (this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.checkScroll)
    }
    
    if (this.leftButton) {
      this.leftButton.removeEventListener('click', this.scrollLeft)
    }
    
    if (this.rightButton) {
      this.rightButton.removeEventListener('click', this.scrollRight)
    }
  }

}

export default FilterTabsScroll
